import script from "./DomainModelWriteModelFields.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelWriteModelFields.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelWriteModelFields.vue?vue&type=style&index=0&id=1ed2c438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed2c438"]])

export default __exports__